import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../../../shared/shared.module';
import { PrecisionComponent } from './precision.component';
import { PartialsModule } from '../../views-partials/partials.module';
import { PrecisionContainerComponent } from './containers/precision-container/precision-container.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        SharedModule,
        PartialsModule
    ],
    declarations: [
        PrecisionComponent,
        PrecisionContainerComponent
    ]
})

export class PrecisionModule {

}
